// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3Nwv9","select":"Header_select__3Zz0i","clinic":"Header_clinic__3mtjN"};